<template>
	<div>
        <div class="container-fluid">
            <div class="row section-separator">
              <div class="col-sm-12 section-title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                <h3>{{ $t('contact.contact') }}</h3>
              </div>
              <div class="map-image image-bg col-sm-12">
                <div class="container mt-30">
                  <div class="row justify-center">
                    <div class="col-sm-12 col-md-8 mh-footer-address">
                      <div class="col-sm-12 xs-no-padding">
                        <div class="mh-address-footer-item dark-bg shadow-1 media wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                          <div class="each-icon">
                            <i class="fa fa-location-arrow"></i>
                          </div>
                          <div class="each-info media-body">
                            <h4>{{ $t('contact.address') }}</h4>
                            <address>
                                <a href="https://www.amap.com/ssr/search?query_type=TQUERY&query=%E5%8E%86%E4%B8%8B%E5%8C%BA&city=370100&geoobj=117.00%7C36.59%7C117.32%7C36.74&zoom=12.14&isCity=true" target="_blank">{{ $t('contact.addressDetail') }}</a><br>
                                {{ $t('contact.china') }}
                            </address>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 xs-no-padding">
                        <div class="mh-address-footer-item media dark-bg shadow-1 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: none;">
                          <div class="each-icon">
                            <i class="fa fa-envelope"></i>
                          </div>
                          <div class="each-info media-body">
                            <h4>{{ $t('contact.email') }}</h4>
                            <a href="mailto:louis.liu.oneself@hotmail.com">louis.liu.oneself@hotmail.com</a><br>
                            <a href="mailto:1907218861@qq.com">1907218861@qq.com</a>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-12 xs-no-padding">
                        <div class="mh-address-footer-item media dark-bg shadow-1 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.6s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.6s; animation-name: none;">
                          <div class="each-icon">
                            <i class="fa fa-phone"></i>
                          </div>
                          <div class="each-info media-body">
                            <h4>{{ $t('contact.phone') }}</h4>
                            <!-- <a href="callto:+86 159 3597 5736">+86 159 3597 5736</a><br> -->
                            <a href="/">+86 159 **** ****（{{ $t('contact.obtainedAfterAddingWeChat') }}）</a><br>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-sm-12 col-md-6 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                      <v-form ref="contact" v-model="contactValid" class="mt-3">
							<v-text-field v-model="contact.name" :label="$t('contact.name')" :rules="requiredRules" outlined required></v-text-field>
							<v-text-field v-model="contact.phone" :label="$t('contact.phone')" :rules="requiredRules" outlined required></v-text-field>
							<v-text-field v-model="contact.email" :label="$t('contact.email')" :rules="requiredRules" outlined required></v-text-field>
							<v-textarea v-model="contact.message" :label="$t('contact.message')" :rules="requiredRules" outlined required></v-textarea>
							<div class="btn-form col-sm-12">
								<div class="btn btn-fill wow fadeInUp btn-block" @click="submitContact()">
									{{ submitLoading ? $t('contact.submitLoading') : $t('contact.submit') }}
								</div>
							</div>
							<div v-if="submitResult != null">
								<span>{{ submitResult }}</span>
							</div>
					  </v-form>
                    </div> -->
                    <div class="col-sm-12 mh-copyright wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="text-left text-xs-center">
                            <p>{{ $t('contact.allRightReserved') }} &copy; 2022 {{ currentYear > 2022 ? (' - ' + currentYear) : '' }} {{ $t('home.liuxin') }}</p>
							<p>
                                <a href="https://beian.miit.gov.cn" target="_blank" class="icp">沪ICP备2022022392号</a>
                            </p>
                            <p>
                                <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502019131" target="_blank">
                                    <img src="/static/icons/beian/gongwanganbei.png" class="gongwanganbei"/>沪公网安备 31011502019131号
                                </a>
                            </p>
                          </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="mh-icon-info" >
                                <div class="social-icon">
                                    <ul class=" ">
                                        <li><a target="_blank" href="/static/images/profile/wechat.png"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-weixin</v-icon></a></li>
                                        <li><a target="_blank" href="/static/images/profile/qq.png"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-qq</v-icon></a></li>
                                        <li><a target="_blank" href="https://join.skype.com/invite/UXz3DrrMVzjh"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-skype</v-icon></a></li>
                                        <li><a target="_blank" href="https://www.linkedin.com/in/louisliuoneself"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-linkedin</v-icon></a></li>
                                      </ul>
                                      <br/>
                                      <ul class="social-icon mt-3">
                                        <li><a target="_blank" href="https://github.com/LouisLiu00"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-github</v-icon></a></li>
                                        <li><a target="_blank" href="https://twitter.com/LouisLiuOneself"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-twitter</v-icon></a></li>
                                        <li><a target="_blank" href="https://www.facebook.com/LouisLiuOneself"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-facebook</v-icon></a></li>
                                        <li><a target="_blank" href="https://t.me/Louis_Liu"><v-icon size="18" color="white" style="padding: 10px;">fa-brands fa-telegram</v-icon></a></li>
                                      </ul>
                                </div>
                            </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
	</div>
</template>
<script>
import ContactAPI from '@/api/contact.js'
export default {
    data(){
        return {
			contactValid: true,
			requiredRules: [
				v => !!v || this.$t('contact.fillField')
			],
			// 联系参数
			contact: {
				name: null,
				phone: null,
				email: null,
				message: null
			},
			// 正在提交
			submitLoading: false,
			// 提交结果
			submitResult: null
        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {
      currentYear(){
        return this.$tools.getCurrentYear();
      }
    },
    watch:{

    },
    methods: {
		// 提交联系
		async submitContact(){
			this.submitResult = null;
			if(this.$refs.contact.validate()){
				if(this.submitLoading){
					return;
				}
				this.submitLoading = true;
				let res = await ContactAPI.submit(this.contact);
				let data = res.data;
				this.submitResult = data.message;
				if(data.code == 200) {
					// 重置表单
					this.$refs.contact.reset();
				}
				this.submitLoading = false;
			}
		}
    }
}
</script>
<style scoped>
.gongwanganbei{
    width: 15px; 
    height: 15px; 
    margin-bottom: 3px; 
    margin-right: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue